import classes from "./ReferenceItem.module.css";
import {Group, List, Loader, Stack, Text, ThemeIcon} from "@mantine/core";
import IconArrowUpRight from "../../../assets/arrow-up-right.svg?react";
import {ExperimentalLink} from "../../../components/ExperimentalLink";
import {resolveDibHref} from "../../../utils/dibUrls";

type ReferenceItemProps = {
    id?: string;
    content?: string;
    href?: string;
    index?: number;
    desc?: string;
    type?: string;
    isTool?: boolean;
    isFeedback?: boolean;
    /** Called when the user opens the reference (metrics). */
    onOpen?: () => void;
};

export const ReferenceItem = ({
    id,
    content,
    href,
    index,
    desc,
    type,
    isTool,
    isFeedback,
    onOpen,
}: ReferenceItemProps) => {
    if (!id) {
        return null;
    }

    const goodHref = resolveDibHref(href);

    const linkContent = (
        <Group gap="xs" align={"flex-start"} wrap="nowrap">
            {!isTool && (
                <ThemeIcon
                    size="xs"
                    radius="xl"
                    variant="filled"
                    color="var(--dib-ink)"
                    w="1.5rem"
                    h="1.5rem"
                    mr="xs"
                    style={{flexShrink: 0}}
                    className={classes.indexWrapper}
                >
                    <Text span ff="text" className={classes.index}>
                        {index}
                    </Text>
                </ThemeIcon>
            )}

            <Stack gap={0} style={{flex: 1, minWidth: 0}}>
                <Group gap={0} wrap="nowrap" align="flex-start" style={{width: "100%"}}>
                    <Text
                        className={
                            classes.content +
                            (isFeedback
                                ? " " + classes.feedbackContent
                                : "")
                        }
                    >
                        {content}
                    </Text>
                    {goodHref ? (
                        <IconArrowUpRight
                            className={
                                classes.chevron +
                                (isFeedback
                                    ? " " + classes.feedbackContent
                                    : "")
                            }
                        />
                    ) : (
                        <Loader
                            style={{alignSelf: "flex-end"}}
                            color="gray"
                            size="xs"
                            type="dots"
                        />
                    )}
                </Group>
                <Text fz="sm" className={classes.description}>
                    {desc || type}
                </Text>
            </Stack>
        </Group>
    );

    return (
        <List.Item id={`reference${id}`} className={classes.item}>
            <ExperimentalLink
                href={goodHref}
                className={classes.link}
                onClick={onOpen}
            >
                {linkContent}
            </ExperimentalLink>
        </List.Item>
    );
};
